import { FormProvider, yupResolver } from '@slal/ui/react-hook-form/core';
import { Field, FieldSet, RadioFieldGroup } from '@slal/ui/react-hook-form/fields';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { MaxWidthContent, StyledForm } from '~/components';
import { useApplicationForm } from '~/hooks';
import { withdrawalOptionsValidationSchema } from '~/schemas';
import { ApplicationFormKeys, WithdrawalOptionsSchema } from '~/types';
import { ApplicationButtons } from '../ApplicationButtons';
import { initialValues, withdrawalOptions } from './utils';

export const WithdrawalOptionsForm = () => {
    const { handleSubmit, form } = useApplicationForm<WithdrawalOptionsSchema>(
        {
            defaultValues: initialValues,
            resolver: yupResolver(withdrawalOptionsValidationSchema),
        },
        ApplicationFormKeys.WITHDRAWAL_OPTIONS
    );
    const navigate = useNavigate();
    const onValidCallback = useCallback(() => {
        const {
            withdrawal: { option },
        } = form.getValues();
        const path = option === 'Regular income' ? 'regular-income' : 'lump-sum-options';
        navigate(`/application/${path}`);
    }, [form]);

    return (
        <MaxWidthContent>
            <FormProvider {...form}>
                <StyledForm onSubmit={handleSubmit(onValidCallback)}>
                    <FieldSet aria-label="Withdrawal options">
                        <Field errorFor="withdrawal.option">
                            <RadioFieldGroup name="withdrawal.option" options={withdrawalOptions} stacked />
                        </Field>
                    </FieldSet>
                    <ApplicationButtons backTo="/application/pensions" />
                </StyledForm>
            </FormProvider>
        </MaxWidthContent>
    );
};
